import Badge from '../../../../components/badge'
import BrandLogo from './brandLogo'
import Currency from '../../../../components/currency'
import Image from 'react-bootstrap/lib/Image'
import Link from 'react-router/lib/Link'
import PropTypes from 'prop-types'
import React from 'react'
import {TrackingConsumer} from '../../../../components/tracking'
import {canonicalizeProduct} from '../../../../shared/canonicalize'
import {colors} from '../../../../styles'
import {css} from 'glamor'
import {bankersRounding} from '../../../../lib/helpers/currency'

const ignoreMarketingUpsellLabels = {
  'Top Seller': true,
  'Youth Top Seller': true
}

const style = {
  container: css({
    display: 'block',
    fontSize: '12px',
    lineHeight: '16px',
    position: 'relative',
    '& > a > div, & > div': {
      marginTop: '5px',
      '&:first-child': {
        marginTop: 0
      }
    }
  }),
  overlay: css({
    bottom: 0,
    height: 'auto',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100%'
  }),
  product: css({
    zIndex: -1,
    '& img': {
      width: '100%'
    }
  }),
  price: css({
    color: colors.black
  }),
  salePrice: css({
    color: colors.saleRed
  }),
  originalPrice: css({
    color: colors.black,
    textDecoration: 'line-through',
    display: 'block'
  }),
  savings: css({
    color: colors.salemGreen,
    display: 'block'
  })
}

const ProductTile = ({
  children,
  fullSize,
  imageHost,
  serverHost,
  product,
  store,
  activity
}) => {
  let price = product.PriceRegular || product.rp
  let salePrice

  if (product.Promo) {
    salePrice = bankersRounding(price * (1 - product.Promo.DiscountValue / 100))
  }

  const label = (product.ProductName || product.Name)
    .replace(new RegExp(store.StoreName, 'i'), '')
    .trim()

  return (
    <div className="product-tile" {...style.container}>
      <TrackingConsumer>
        {(push) => (
          <Link
            onClick={() =>
              push({
                action: 'click',
                design: product.Design.DesignID,
                product: product.ProductID
              })
            }
            to={canonicalizeProduct(store, product, {activity})}
            title={label}
          >
            <div className="text-center">
              <div {...(fullSize ? style.product : {})}>{children}</div>
              {product.Overlay ? (
                <Image
                  src={`${imageHost}/productimages/promos/${product.Overlay}`}
                  {...style.overlay}
                />
              ) : null}
            </div>
            {product.Brand && (
              <div>
                <BrandLogo
                  serverHost={serverHost}
                  brand={product.Brand}
                  small
                />
              </div>
            )}
            {product.MarketingUpsell &&
            product.MarketingUpsell.Enabled &&
            !ignoreMarketingUpsellLabels[product.MarketingUpsell.Label] ? (
              <div>
                <Badge kind={product.MarketingUpsell.Type}>
                  {product.MarketingUpsell.Label}
                </Badge>
              </div>
            ) : null}
            {product.MarketingUpsellVisible &&
            !ignoreMarketingUpsellLabels[product.MarketingUpsellLabel] ? (
              <div>
                <Badge kind={product.MarketingUpsellCss}>
                  {product.MarketingUpsellLabel}
                </Badge>
              </div>
            ) : null}
            <div>{label}</div>
            {salePrice ? (
              <>
                <div {...style.salePrice}>
                  <strong>
                    <Currency amount={salePrice} />
                  </strong>
                </div>
                <span {...style.originalPrice}>
                  <Currency amount={price} />
                </span>
                <span {...style.savings}>
                  You save: <Currency amount={price - salePrice} />
                </span>
              </>
            ) : (
              <div {...style.price}>
                <strong>
                  <Currency amount={price} />
                </strong>
              </div>
            )}
          </Link>
        )}
      </TrackingConsumer>
    </div>
  )
}

ProductTile.propTypes = {
  children: PropTypes.any,
  fullSize: PropTypes.bool,
  imageHost: PropTypes.string.isRequired,
  serverHost: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  activity: PropTypes.string
}

ProductTile.defaultProps = {
  fullSize: true
}

export default ProductTile
